{
  "project": "المشروع",
  "node": "جزء الخطة",
  "category": "فئة التكلفة",
  "projectOf": "مشروع {{what}}",
  "nodeOf": "بند خطة {{what}}",
  "categoryOf": "فئة تكلفة {{what}}",
  "chooseProject": "اختر مشروعًا",
  "noProject": "بلا مشروع",
  "searchProjects": "ابحث في المشاريع بالرمز أو الاسم…",
  "noProjects": "لا يوجد مشروع مفتوح مطابق.",
  "noRevenueProjects": "لا يوجد مشروع مفتوح لهذا العميل مطابق.",
  "projectsError": "تعذّر تحميل المشاريع.",
  "wholeProject": "المشروع كاملًا",
  "searchNodes": "ابحث في الخطة…",
  "noNodes": "لا يوجد بند خطة مطابق.",
  "auto": "تُحدَّد تلقائيًا",
  "autoHint": "إن تُركت فارغة، تُحدَّد الفئة من ربط التكاليف في الشركة عند حفظ المستند.",
  "autoIs": "تلقائيًا: {{category}}",
  "autoFromSource": "تلقائيًا (من المنتج أو الحساب)",
  "autoFromExpense": "تلقائيًا (من فئة المصروف)",
  "noCategories": "لا توجد فئة مطابقة.",
  "searchCategories": "ابحث في الفئات…",
  "archived": "مؤرشف",
  "tag": "المشروع {{project}}",
  "column": "المشروع",
  "moreProjects_zero": "+{{count}}",
  "moreProjects_one": "+{{count}} آخر",
  "moreProjects_two": "+{{count}} آخران",
  "moreProjects_few": "+{{count}} أخرى",
  "moreProjects_many": "+{{count}} أخرى",
  "moreProjects_other": "+{{count}} أخرى",
  "filter": "التصفية حسب المشروع",
  "allProjects": "كل المشاريع",
  "deliveredToSite": "تسليم إلى الموقع: بلا حركة مخزون",
  "deliveredToSiteHint": "تذهب البضاعة مباشرة إلى المشروع: يُحمَّل الترحيل على حساب تكلفته بدلًا من المخزون.",
  "reducesCost": "يخفّض تكلفة {{project}}",
  "serialBlocked": "لا يمكن ربط بضاعة بأرقام تسلسلية بمشروع: استلمها في المخزون ثم اصرفها إلى المشروع.",
  "notTaggedSerial": "غير مرتبط: بضاعة بأرقام تسلسلية",
  "forAllLines": "مشروع لكل البنود",
  "forAllLinesHint": "يضبط المشروع على كل البنود؛ ويمكن لأي بند تغيير مشروعه.",
  "linesMixed": "بنود على عدة مشاريع",
  "more": "المزيد",
  "moreOf": "المزيد للبند {{n}}: المشروع وجزء الخطة وفئة التكلفة",
  "lineN": "البند {{n}}",
  "lineLabel": "البند {{n}}",
  "copiedTag": "من بند المشتريات: {{tag}}",
  "section": "المشروع",
  "sectionHint": "المشروع الذي تخصه هذه التكلفة. لا يتغير حسابها ولا ترحيلها.",
  "errors": {
    "PROJECT_NOT_OPEN": "المشروع مغلق أو ملغى: اختر مشروعًا مفتوحًا.",
    "PROJECT_SERIAL_GOODS": "لا يمكن ربط بضاعة بأرقام تسلسلية بمشروع: استلمها في المخزون ثم اصرفها إلى المشروع.",
    "PROJECTS_MODULE_OFF": "المشاريع معطّلة لشركتك: لا يمكن ضبط ربط جديد بمشروع.",
    "PROJECT_FEATURE_OFF": "لا يستخدم المشروع خطة: اترك جزء الخطة فارغًا."
  }
}
